import { ActiveMarkup, EmploymentBoardDecisionLockViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { Feedback, SpeechBubble, Text } from '@foradevelopment/fora-ui';

import { CurrentMarkupInfo } from './MarkupAndParametersForm/CurrentMarkupInfo';
import { useTypedTranslation } from '../../i18n/i18n';

export const MarkupChangesLocked = ({
  activeMarkup,
  boardDecisionLock,
  type,
}: {
  activeMarkup?: ActiveMarkup | null;
  boardDecisionLock: EmploymentBoardDecisionLockViewModel;
  type: 'speechBubble' | 'feedback';
}) => {
  return type === 'speechBubble' ? (
    <>
      {activeMarkup && <CurrentMarkupInfo activeMarkup={activeMarkup} />}
      <SpeechBubble color="babyYellow" marginTop={30}>
        <MarkupChangesLockedContent boardDecisionLock={boardDecisionLock} />
      </SpeechBubble>
    </>
  ) : (
    <Feedback type="warning" marginBottom={40} negativeSideMargins iconAbove>
      <MarkupChangesLockedContent boardDecisionLock={boardDecisionLock} />
    </Feedback>
  );
};

const MarkupChangesLockedContent = ({
  boardDecisionLock,
}: {
  boardDecisionLock: EmploymentBoardDecisionLockViewModel;
}) => {
  const { t } = useTypedTranslation();

  return (
    <>
      <Text size="small">{t('form.editEmployee.lockedMarkupWarningText')}</Text>
      {boardDecisionLock.validToDate && (
        <Text size="small">
          {t('form.editEmployee.lockedMarkupWarningTextEndDate', {
            endDate: boardDecisionLock.validToDate,
          })}
        </Text>
      )}
    </>
  );
};
